jQuery(document).scroll(function() {

        var documentTop = jQuery(document).scrollTop();
        console.log('this is current top of your document' + documentTop );
        //box top is 891
        if (documentTop > 1200) {
            //change the value of the css at this point
            jQuery(".product-form__submit").addClass("stayfix");
        }
        else        
        {
            jQuery(".product-form__submit").removeClass("stayfix");
        }
});